module.exports = __webpack_public_path__ + "img/c93134e2-3434-464e-b6e0-e393a07e7955.c8e6860f.jpg";